
export const getRouteInfo = ()=>{
  const currentUrl = new URL(window.location.href);
  let { href: url, searchParams, hostname: domain } = currentUrl;
  searchParams = Object.fromEntries(searchParams.entries());

  ([url] = url.split('?'));
  let [baseUrl, ...route] = url.split(/(?<!\/)\/(?!\/)/);
  url = url.replace(/\/$/, '');
  
  route = route.map(decodeURIComponent);

  return {
    url, baseUrl, domain, 
    route, searchParams,
  }
}